// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { ArticuloProps } from '../../../interfaces/articulo.ts'

const query = gql`
  mutation ELIMINAR($cds: Int!, $codigoArticulo: String!) {
    articuloEliminar(cds: $cds, codigoArticulo: $codigoArticulo)
  }
`

/**
 * Actualizamos los datos de un articulo
 * @param cds
 * @param codigoArticulo
 */
export const apiArticuloEliminar = async (
  cds: number,
  codigoArticulo: string,
): Promise<ArticuloProps> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)

    const data: any = await client.request(query, { cds, codigoArticulo })
    return data.articuloEliminar
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
